import { Store } from './store';
import { NumberOfLineItems } from './numberOfLineItems';
import { ItemName } from './itemName';
import { TotalQuantity } from './totalQuantity';
import { ItemSKU } from './itemSKU';
import { RequestedService } from './requestedService';
import { Country } from './country';

export const groupByArr = [Store, NumberOfLineItems, ItemName, TotalQuantity, ItemSKU, RequestedService, Country];

export const GroupByEnums = groupByArr.reduce((acc, curr) => {
  return {
    ...acc,
    [curr.id]: curr,
  };
}, {});
